<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :keyDateFrom="filterProps.dateFrom"
      :keyDateTo="filterProps.dateTo"
      :keyStatus="filterProps.status"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyDateFrom="filterProps.dateFrom"
        :keyDateTo="filterProps.dateTo"
        :keyStatus="filterProps.status"
        @createCostFlow="createCostFlow"
        @clearKey="clearKey"
      />
      <ul class="tabs">
        <li>
          <router-link to="/profit/">{{
            $t("other.利润报表管理")
          }}</router-link>
        </li>
        <li>
          <a class="active" href="javascript:;">{{
            $t("other.其他支出流水管理")
          }}</a>
        </li>
      </ul>
      <router-view
        v-if="isSysRights('Profit.findOtherCostFlow')"
        :first_loading="firstLoading"
        :items="items"
        @showOperateLog="showOperateLog"
        @cancelCostFlow="cancelCostFlow"
        @modiCostFlow="modiCostFlow"
      >
      </router-view>
      <no-rights v-else></no-rights>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/cost-flow/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
      <Modal
        :modalId="'modalCreateCostFlow'"
        :home="false"
        :loading="modalCreateCostFlow.loading"
        :size="'md'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{
                modalCreateCostFlow.id
                  ? $t("other.修改支出流水")
                  : $t("other.添加支出流水")
              }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="form-group row">
              <label class="col-3 col-form-label form-control-sm text-right">
                {{ $t("other.统计时段：") }}<span class="tx-danger">*</span>
              </label>
              <div class="col-8 datepicker-group d-flex">
                <div class="input-group mg-r-5 col-5 pd-l-0">
                  <input
                    data-id="datepicker-from"
                    type="text"
                    class="form-control fc-datepicker form-control-sm"
                    :placeholder="$t('other.选择日期')"
                    readonly="true"
                    v-model="modalCreateCostFlow.timeCreated"
                  />
                </div>
                <div class="mg-r-5">
                  <select
                    class="form-control form-control-sm"
                    v-model="modalCreateCostFlow.hh"
                  >
                    <option value="">{{ $t("other.时") }}</option>
                    <option v-for="h in 23" :value="h" :key="h">
                      {{ h | formatH }}
                    </option>
                  </select>
                </div>
                <div>
                  <select
                    class="form-control form-control-sm"
                    v-model="modalCreateCostFlow.mm"
                  >
                    <option value="">{{ $t("other.分") }}</option>
                    <option v-for="m in 59" :value="m" :key="m">
                      {{ m | formatH }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-3 col-form-label form-control-sm text-right">
                {{ $t("other.流水备注：") }}
              </label>
              <div class="col-8">
                <textarea
                  rows="2"
                  class="form-control form-control-sm"
                  v-model="modalCreateCostFlow.remark"
                ></textarea>
              </div>
            </div>
            <div class="mg-b-0 form-group row">
              <label class="col-3 col-form-label form-control-sm text-right">
                {{ $t("other.支出资金：") }}<span class="tx-danger">*</span>
              </label>
              <div class="col-4 d-flex align-items-center">
                <input
                  class="mg-r-5 form-control form-control-sm"
                  type="text"
                  v-PRICE
                  v-model="modalCreateCostFlow.amount"
                />
                <span>{{ $t("other.元") }}</span>
              </div>
            </div>
            <div class="mg-b-0 row">
              <div class="col-3"></div>
              <div class="col-8">
                ({{
                  $t("other.该项支出金额将会作为其他支出成本统计在利润报表中")
                }})
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-primary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveCreateCostFlow"
              >
                {{ $t("other.保存") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("other.关闭") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalProfitLog'"
        :home="false"
        :loading="false"
        :size="'md'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("other.操作日志") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <ul class="row">
              <li
                v-for="item in modalProfitLog.items"
                :key="item"
                class="mg-b-10 col-12"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("other.关闭") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
      <Modal
        :modalId="'modalCancelCostFlow'"
        :home="false"
        :loading="modalCancelCostFlow.loading"
        :size="'sm'"
        :autoH="false"
      >
        <template slot="header">
          <div class="modal-header pd-y-20 pd-x-25">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("other.作废流水：") }}
            </h6>
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
        </template>
        <template slot="body">
          <div class="body-inner">
            <div class="row">
              <div class="col-12">
                {{ $t("other.确定要作废流水吗？") }}
              </div>
            </div>
          </div>
        </template>
        <template slot="footer">
          <div class="modal-footer d-block pd-y-15 pd-x-0">
            <div
              class="
                form-group
                row
                align-items-center
                justify-content-end
                pd-x-25
                mg-b-0
              "
            >
              <button
                type="button"
                class="
                  mg-r-30
                  btn btn-danger
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="saveCancelCostFlow"
              >
                {{ $t("other.作废") }}
              </button>
              <button
                type="button"
                class="
                  btn btn-secondary
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                data-dismiss="modal"
              >
                {{ $t("other.取消") }}
              </button>
            </div>
          </div>
        </template>
      </Modal>
    </div>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; // 左边栏
import Header from "./header.vue"; // 头
import Modal from "@components/Modal";
import { pagination } from "@components/pagination.js"; // 分页

export default {
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), // 左边栏状态
      firstLoading: true,
      loading: false,
      page: this.$route.params.page ? this.$route.params.page : 1,
      totalPage: 1,
      rowsPerPage: parseInt(store.get("costFlow-rowsPerPage"))
        ? parseInt(store.get("costFlow-rowsPerPage"))
        : 10,
      pageSizeSelect: [10, 20, 50],
      totalCount: 0,
      items: [],
      filterProps: {
        dateFrom: "",
        dateTo: "",
        status: "",
      },
      modalCreateCostFlow: {
        loading: false,
        mode: 1,
        id: "",
        timeCreated: "",
        hh: "",
        mm: "",
        amount: "",
        remark: "",
      },
      modalCreateCostFlowDefault: "",
      modalCancelCostFlow: {
        loading: false,
        id: "",
      },
      modalProfitLog: {
        items: [],
      },
    };
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("costFlow-rowsPerPage", this.rowsPerPage);
    },
  },
  filters: {
    formatH(val) {
      return val < 10 ? "0" + val : val;
    },
  },
  methods: {
    // 保存作废
    saveCancelCostFlow() {
      this.modalCancelCostFlow.loading = true;
      $.api_call(
        "api.Profit.cancelOtherCostFlow",
        { id: this.modalCancelCostFlow.id },
        (r) => {
          this.modalCancelCostFlow.loading = false;
          if (r.ErrorCode == "9999") {
            this.getItems(true);
            ShowTip(this.$t("other.作废流水成功"), "success");
            $("#modalCancelCostFlow").modal("hide");
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    // 打开作废
    cancelCostFlow(item) {
      this.modalCancelCostFlow.loading = false;
      this.modalCancelCostFlow.id = item.id;
      $("#modalCancelCostFlow").modal("show");
    },
    // 显示日志
    showOperateLog(item) {
      if (item.length) {
        this.modalProfitLog.items = item;
        $("#modalProfitLog").modal("show");
      }
    },
    saveCreateCostFlow() {
      if (!this.modalCreateCostFlow.timeCreated) {
        ShowTip(this.$t("other.请选择统计日期"), "danger");
        return;
      }
      if (!this.modalCreateCostFlow.amount) {
        ShowTip(this.$t("other.请输入支出金额"), "danger");
        return;
      }
      let timeCreated =
        this.modalCreateCostFlow.timeCreated +
        " " +
        (this.modalCreateCostFlow.hh ? this.modalCreateCostFlow.hh : "00") +
        ":" +
        (this.modalCreateCostFlow.mm ? this.modalCreateCostFlow.mm : "00");
      this.modalCreateCostFlow.loading = true;
      let params = {
        timeCreated,
        amount: this.modalCreateCostFlow.amount,
        remark: this.modalCreateCostFlow.remark,
      };
      let url =
        this.modalCreateCostFlow.mode == 1
          ? "api.Profit.addOtherCostFlow"
          : "api.Profit.changeOtherCostFlow";
      if (this.modalCreateCostFlow.mode == 2)
        params.id = this.modalCreateCostFlow.id;
      $.api_call(url, params, (r) => {
        this.modalCreateCostFlow.loading = false;
        if (r.ErrorCode == "9999") {
          this.getItems(true);
          ShowTip(
            `${
              this.modalCreateCostFlow.mode == 1
                ? $t("other.添加")
                : $t("other.修改")
            }${this.$t("other.支出流水成功")}`,
            "success"
          );
          $("#modalCreateCostFlow").modal("hide");
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    // 修改流水
    modiCostFlow(item) {
      this.modalCreateCostFlow = JSON.parse(this.modalCreateCostFlowDefault);
      this.modalCreateCostFlow.mode = 2;
      this.modalCreateCostFlow.id = item.id;
      this.modalCreateCostFlow.amount = item.amount;
      this.modalCreateCostFlow.remark = item.remark;
      this.modalCreateCostFlow.timeCreated = moment(
        item.timeCreated,
        "YYYY-MM-DD hh:mm:ss"
      ).format("YY-MM-DD");
      this.modalCreateCostFlow.hh = moment(
        item.timeCreated,
        "YYYY-MM-DD hh:mm:ss"
      ).hour();
      this.modalCreateCostFlow.mm = moment(
        item.timeCreated,
        "YYYY-MM-DD hh:mm:ss"
      ).minute();
      this.datepickerSelect();
      $("#modalCreateCostFlow").modal("show");
    },
    // 创建流水
    createCostFlow() {
      this.modalCreateCostFlow = JSON.parse(this.modalCreateCostFlowDefault);
      this.datepickerSelect();
      $("#modalCreateCostFlow").modal("show");
    },
    getItems(s) {
      if (!this.isSysRights("Profit.findOtherCostFlow")) return;
      this.loading = true;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        dateFrom: this.filterProps.dateFrom,
        dateTo: this.filterProps.dateTo,
        status: this.filterProps.status,
      };
      $.api_call("api.Profit.findOtherCostFlow", params, (r) => {
        this.loading = false;
        console.log(r);
        if (r.ErrorCode == "9999") {
          this.firstLoading = false;
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          if (!s) $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    filtrate(dateFrom, dateTo, status) {
      (this.filterProps = {
        dateFrom,
        dateTo,
        status,
      }),
        this.toPage(1);
    },
    clearKey(type) {
      this.filterProps[type] = "";
      this.toPage(1);
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/cost-flow/" + 1 });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/cost-flow/" + num });
      if (page == num) {
        this.getItems();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
    datepickerSelect() {
      let vm = this;
      // 日期控件初始化
      $("#modalCreateCostFlow [data-id]").each(function () {
        $(this).datepicker({
          numberOfMonths: 1,
          dateFormat: "yy-mm-dd",
          onSelect: function (selectedDate) {
            vm.modalCreateCostFlow.timeCreated = selectedDate;
          },
        });
      });
    },
  },
  mounted() {
    this.getItems();
    this.modalCreateCostFlowDefault = JSON.stringify(this.modalCreateCostFlow);
    $("#modalProfitLog").on("shown.bs.modal", function (e) {
      // 备注打开后滚到顶
      $("#modalProfitLog .modal-body").scrollTop(0);
    });
  },
};
</script>

<style lang="less" scoped>
.body-inner {
  [data-id="datepicker-from"],
  [data-id="datepicker-to"] {
    background-color: #fff;
    border-color: rgba(0, 0, 0, 0.15);
    color: #495057;
  }
  ul {
    padding: 0;
    list-style: none;
    margin-bottom: 0;
  }
}
.nav.nav-outline {
  padding: 0 15px;
}
</style>